import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { OwnProps } from './index';
import { selectSprayWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (state: AppState, props: OwnProps): ProductId =>
    props.productId;

const selectProductRatePerTank = createDeepEqualSelector(
    selectSprayWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'unitsPerTank'])
);

const makeSelectProductRatePerTank = (): typeof selectProductRatePerTank =>
    selectProductRatePerTank;

const selectProductUnitType = createDeepEqualSelector(
    selectSprayWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'sprayProduct', 'unitType', 'name'])
);

const makeSelectProductUnitType = (): typeof selectProductUnitType =>
    selectProductUnitType;

export {
    selectProductId,
    makeSelectProductRatePerTank,
    makeSelectProductUnitType
};
